import { useEffect, useState } from 'react';

import { Globe02Icon, Search01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { LANGUAGE_MAP } from 'constants/countries';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';

export const SupportedLanguagesModal = ({ visible, onClose = () => {} }) => {
  const [filteredLanguages, setFilteredLanguages] = useState([]);

  const handleLanguageSearch = value => {
    setFilteredLanguages(
      Object.values(LANGUAGE_MAP).filter(language =>
        language?.toLowerCase()?.includes(value?.toLowerCase()),
      ),
    );
  };

  useEffect(() => {
    setFilteredLanguages(Object.values(LANGUAGE_MAP));
  }, []);

  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      title="Supported languages"
      description="You can complete this form in any of these languages. Please enable the language on your keyboard before typing."
      icon={Globe02Icon}
      oldIconLibrary={false}
      small>
      {visible && (
        <div>
          <div className="u-margin-bottom position-relative u-margin-top--large">
            <HugeiconsIcon icon={Search01Icon} size="16" className="search-icon secondary-text" />
            <input
              name="language_search"
              placeholder="Search for your language"
              onChange={e => handleLanguageSearch(e.target.value)}
              tabIndex={1}
              className="search-input"
            />
          </div>
          <div className="d-flex flex-column u-height-200 u-overflow-y--auto u-border u-border-radius">
            {filteredLanguages.map(language => (
              <div
                key={language}
                className="d-flex flex-col u-gap-small align-items-center u-border-bottom u-padding--small">
                <span className="secondary-text u-font-size-x-small u-font-weight-400">
                  {language}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </AnimatedModal>
  );
};
